(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const restoreCollectionCard = () => {
    if (!window.location.hash) return;
    let anchorId;
    try {
      anchorId = decodeURIComponent(window.location.hash.slice(1));
    } catch (_) {
      return;
    }
    const card = document.getElementById(anchorId);
    if (!card) return;
    requestAnimationFrame(() => card.scrollIntoView({ behavior: 'instant', block: 'center' }));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreCollectionCard, { once: true });
  } else {
    restoreCollectionCard();
  }
  window.addEventListener('pageshow', restoreCollectionCard);

  } catch(e) { console.error(e); }
})();
})();
